<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Games
            </v-row>
            <v-divider />
            <div v-if="games.length > 0">
                <!--games table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col v-for="(item, i) in headers" :key="i" 
                        class="tabCell"
                        :cols=" item.cols"
                        :class="item.style">
                        {{ item.title }}
                    </v-col>
                </v-row>
                <!-- games tab -->
                <v-row v-for="game in games" :key="game.id" no-gutters>
                    <v-col cols="1" class="tabCell text-left">{{ game.id }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ game.category }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ game.round }}</v-col>
                     <v-col cols="1" class="tabCell text-center">{{ game.rounds }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ game.num_teams }}</v-col>
                    <v-col cols="3" class="tabCell text-center">{{ game.description }}</v-col>

                    <v-col cols="1" class="tabCell text-center">{{ game.userId }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ game.user.name }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ game.user.role }}</v-col>  
                    <v-col cols="1" class="tabCell text-right">
                        <edit-game :game="game" />
                        <delete-game :game="game" />
                    </v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-8 px-4">
                You haven't games yet!
            </v-row>
        </div>
    </v-container>
</template>
<script>
import editGame from '../../../components/admin/games/editGame.vue';
import deleteGame from '../../../components/admin/games/deleteGame.vue'

export default {
    name: 'Games',
    data() {
        return {
            headers: [
                { title: 'Game id', style: 'text-left', cols: 1 },
                { title: 'Category', style: 'text-center', cols: 1 },
                { title: 'Current round', style: 'text-center', cols: 1 },
                { title: 'Rounds', style: 'text-center', cols: 1 },
                { title: 'Number of teams', style: 'text-center', cols: 1 },
                { title: 'Description', style: 'text-center', cols: 3 },
                { title: 'Creator\'s id', style: 'text-center', cols: 1 },
                { title: 'Creator\'s name', style: 'text-center', cols: 1 },
                { title: 'Creator\'s role', style: 'text-center', cols: 1 },
                { title: 'Actions', style: 'text-right', cols: 1 },
            ]
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        games() {
            console.log(this.$store.getters.games);
            return this.$store.getters.games;
        }
    },
    methods: {
        dateToString(date) {
            return date.toLocaleString('en-GB', { timeZone: 'UTC' }).substr(0, 10);
        },
    },
    components: { deleteGame, editGame },
    async mounted() {
        try {
            await this.$store.dispatch('fetchAllGames')
        }
        catch (error) {
            console.log(error.message);
        }
    }
}
</script>